import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { useElementBounding } from '@vueuse/core';
import { nextTick, ref, watch } from 'vue';

export type SharedProgressBarEmits = {};

export type SharedProgressBarProps = {
	color?: Orion.Color
	width?: number
	value?: number
	gradientValue?: number
	gradientColor?: Orion.Color
	tooltip?: string
};

export default class SharedProgressBarSetup extends BaseSetup {

	static readonly defaultProps = {
		color: 'info' as Orion.Color,
		width: 4,
		value: 0,
		gradientColor: 'warning' as Orion.Color,
		tooltip: '0%',
	};

	private _el = ref<RefDom>();
	private _value = ref<RefDom>();
	private _mask = ref<RefDom>();

	@Reactive private readonly state = { _elBounding: useElementBounding(this._el) };

	private get elWidth () { return this.state._elBounding.width }

	constructor (
		private props: SharedProgressBarProps,
		private emits: SharedProgressBarEmits,
	) {
		super();
	}

	protected onMounted (): void {
		nextTick(() => this.handleMask());

		watch(this.state._elBounding, () => {
			nextTick(() => this.handleMask());
		});
	}

	private handleMask () {
		if (!this._mask.value || !this._value.value) return;

		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.innerHTML = this._mask.value.innerHTML;

		let str = new XMLSerializer().serializeToString(svg);
		str = 'data:image/svg+xml;charset=utf8,' + encodeURIComponent(str);

		this._value.value.style.webkitMaskImage = `url(${str})`;
		this._value.value.style.maskImage = `url(${str})`;
	}

}
